/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mantine/core';
import { Link } from 'react-router-dom';
import AppFlexbox from '../../../common/AppFlexbox';
import HoverableAnchor from '../../../common/HoverableAnchor';

const VIEW_ALL_STYLE_ENUM = {
  LINK: 'LINK',
  OUTLINE_BUTTON: 'OUTLINE_BUTTON',
  SOLID_BUTTON: 'SOLID_BUTTON'
};

const WsSectionViewAllButtons = ({
  buttonStyleType,
  colorScheme,
  url,
  onNavigate
}) => (
  <AppFlexbox
    style={{
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 20
    }}
  >
    {buttonStyleType === VIEW_ALL_STYLE_ENUM.LINK ? (
      <HoverableAnchor
        component={Link}
        onClick={onNavigate}
        style={{ color: colorScheme.textColor }}
        to={url}
      >
        View all
      </HoverableAnchor>
    ) : buttonStyleType === VIEW_ALL_STYLE_ENUM.OUTLINE_BUTTON ? (
      <Button
        color={colorScheme.outlineButtonColor}
        component={Link}
        onClick={onNavigate}
        radius={0}
        size="md"
        to={url}
        variant="outline"
      >
        View all
      </Button>
    ) : (
      <Button
        color={colorScheme.solidButtonColor}
        component={Link}
        onClick={onNavigate}
        radius={0}
        size="md"
        style={{ color: colorScheme.solidButtonLabel }}
        to={url}
        variant="filled"
      >
        View all
      </Button>
    )}
  </AppFlexbox>
);

WsSectionViewAllButtons.propTypes = {
  buttonStyleType: PropTypes.string,
  colorScheme: PropTypes.object,
  onNavigate: PropTypes.func,
  url: PropTypes.string
};

export default WsSectionViewAllButtons;
